import { Box, Button, Typography } from "@mui/material";
import { HomeButton } from "../../../../domain/model/HomeButton";
import { CustomImageView } from "../../../component/CustomImageView";
import { FIGTREE_FONT_FAMILY } from "../../../../data/constant/Constants";
import {
  COLOR_LOGIN_CARD_BLACK,
  COLOR_MAIN_COLOR_BLUE,
} from "../../../../data/colors/Colors";
import { useState } from "react";

interface props {
  currentIndex: number;
  homeButton: HomeButton;
  handleOnclick: (homeButton: HomeButton) => void;
}
export function HomeButtonItemView(props: props) {
  const [showTitle, SetShowTitle] = useState(false);

  return (
    <Box
      paddingLeft={props.currentIndex === 0 ? 2 : 0}
      paddingBottom={props.currentIndex === 0 ? 4 : 0}
      paddingTop={props.currentIndex === 0 ? 4 : 0}
    >
      <Button
        onClick={() => props.handleOnclick(props.homeButton)}
        onMouseEnter={() => {
          SetShowTitle(true);
        }}
        onMouseLeave={() => {
          SetShowTitle(false);
        }}
        sx={{
          borderRadius: 6,
          padding: 0,
          transition: "transform 0.4s ease-in-out",
          "&:hover": { transform: "scale3d(1.08, 1.08, 1)", zIndex: "1" },
          position: "relative",
        }}
      >
        <CustomImageView
          width={props.currentIndex === 0 ? "30vh" : "35vh"}
          height={props.currentIndex === 0 ? "51vh" : "25vh"}
          scale="contain"
          props={{
            borderRadius: 6,
            border: showTitle ? "2px solid white" : "",
            background: `linear-gradient(#002afe,#002afe,#0024d9,#000000,#000000)`,
          }}
          src={
            props.homeButton.image ??
            require("../../../../assets/images/placeholder.png")
          }
        />
        <Box
          position={"absolute"}
          width={props.currentIndex === 0 ? "90%" : "80%"}
          top={props.currentIndex === 0 ? "2%" : "5%"}
          left={props.currentIndex === 0 ? "5%" : "10%"}
          borderRadius={6}
          sx={{
            background: COLOR_LOGIN_CARD_BLACK,
            opacity: !showTitle ? "0" : "1",
            transition: "all .4s",
            visibility: !showTitle ? "hidden" : "visible",
          }}
        >
          <Typography
            textAlign={"center"}
            color={"white"}
            variant="h4"
            fontFamily={FIGTREE_FONT_FAMILY}
            whiteSpace={"nowrap"}
            maxWidth={"300px"}
            overflow={"hidden"}
            textOverflow={"ellipsis"}
            textTransform={"none"}
          >
            {props.homeButton.title}
          </Typography>
        </Box>
      </Button>
    </Box>
  );
}
